(function () {
    'use strict';

    angular
        .module('initiativeUpdateStatusAssessRoutes')
        .directive('planDeliverableAssessment', directive);

    directive.$inject = [];

    function directive() {
        return {
            scope: {
                delivAssessment: '=deliverableAssessment',
                initUpdStatusAssessment: '=initiativeUpdateAssessment',
                // readOnly: '@'
            },
            restrict: 'AE',
            templateUrl: require('./planDeliverableAssessment.tpl.html'),
            controller: ['$scope', '$state', '$stateParams', '$timeout', 'initiativeUpdateStatusService', 'businessPlanningService', 'followUpService',
                function ($scope, $state, $stateParams, $timeout, initiativeUpdateStatusService, businessPlanningService, followUpService) {

                $scope.selectStatus = function (status) {
                    if ($scope.attr.isReadOnly) return;

                    $scope.delivAssessment.AssessmentCompletionStatus   = status;
                    $scope.delivAssessment.AssessmentCompletionStatusID = status.LookupAttributeValueID;

                    if (isInProgress()) {
                        $scope.attr.isInProgress = true;
                    } else if (isCompleted()) {
                        $scope.attr.isCompleted = true;
                    }

                    if (isFieldRequired('AssessmentTargetDate') && _.isUndefined($scope.delivAssessment.AssessmentTargetDate)) {
                        $scope.delivAssessment.AssessmentTargetDate = $scope.delivAssessment.MilestoneGroup.TargetDate;
                    }
                    $scope.initialAssessmentTargetDate = $scope.delivAssessment.AssessmentTargetDate ? $scope.delivAssessment.AssessmentTargetDate : $scope.delivAssessment.MilestoneGroup.TargetDate ;

                    $scope.setDirty();
                };

                $scope.saveAssessment = function () {
                    $scope.attr.isSubmitted = 'True';

                    // Form Invalid
                    if (!$scope.attr.isFormValid) {
                        $scope.attr.isFormInvalidError = true;
                        $timeout(function () {
                            $scope.attr.isFormInvalidError = false;
                        }, 3000);

                        // Require Follow-ups
                        if (areFollowUpsRequired()) {
                            $scope.attr.showRequireFollowUpError = true;
                            $timeout(function () {
                                $scope.attr.showRequireFollowUpError = false;
                            }, 12500);
                        }

                        return;
                    }

                    $scope.attr.isLoading = true;
                    var requestDone = false,
                        timeoutDone = false;
                    $timeout(function () {
                        if (requestDone) {
                            $scope.attr.isLoading = false;
                        } else {
                            timeoutDone = true;
                        }
                    }, 250);

                    initiativeUpdateStatusService
                        .assessDeliverable(
                            $stateParams.ItemPersonID, $scope.delivAssessment.PlanInitiativeID,
                            $scope.delivAssessment.MilestoneGroupID, $scope.delivAssessment)
                        .then(function (deliverableAssessment) {
                            $scope.delivAssessment = deliverableAssessment;
                            $scope.attr.isShowSubmitted = $scope.delivAssessment.IsSubmitted;
                            if ($scope.delivAssessment.AssessmentTargetDate) {
                                $scope.delivAssessment.AssessmentTargetDate =
                                    moment($scope.delivAssessment.AssessmentTargetDate).format();
                            }

                            return initiativeUpdateStatusService
                                    .getAssessmentsByAssessorAndInitiative($stateParams.ItemPersonID, $scope.delivAssessment.PlanInitiativeID)
                                    .then(function (assmntByInitiative) {
                                        $scope.initUpdStatusAssessment.PlanInitiativeAssessment = assmntByInitiative.PlanInitiativeAssessment;

                                        if (timeoutDone) {
                                            $scope.attr.isLoading = false;
                                        } else {
                                            requestDone = true;
                                        }
                                    });

                    });
                };

                $scope.resetAssessment = function () {
                    if ($scope.attr.isReadOnly) return;

                    $scope.attr.isLoading = true;
                    initiativeUpdateStatusService
                        .resetDeliverableAssessment(
                            $stateParams.ItemPersonID, $scope.delivAssessment.PlanInitiativeID,
                            $scope.delivAssessment.MilestoneGroupID, $scope.delivAssessment)
                        .then(function (resetedAssessment) {
                            $scope.delivAssessment = resetedAssessment;

                            return initiativeUpdateStatusService
                                    .getAssessmentsByAssessorAndInitiative($stateParams.ItemPersonID, $scope.delivAssessment.PlanInitiativeID)
                                    .then(function (assmntByInitiative) {
                                        $scope.initUpdStatusAssessment.PlanInitiativeAssessment = assmntByInitiative.PlanInitiativeAssessment;

                                        $scope.init();
                                    });
                        }
                    );
                };

                $scope.editAssessment = function () {
                    $scope.attr.isShowSubmitted = false;
                };

                $scope.setDirty = function () {
                    if ($scope.delivAssessment.AssessmentCompletionStatusID) {
                        // Check if there are required fields and if they are provided
                        $scope.attr.isFormValid = areAllFieldsValid();
                    } else {
                        $scope.attr.isShowActions = false;
                    }
                };

                $scope.completionPercentageChanged = function () {
                    if ($scope.attr.completionPercentage > 0) {
                        $scope.attr.isCompletionPercentageValid = true;
                        $scope.delivAssessment.AssessmentCompletionPercentage = $scope.attr.completionPercentage;
                    } else {
                        $scope.attr.isCompletionPercentageValid = false;
                        $scope.delivAssessment.AssessmentCompletionPercentage = null;
                    }
                    $scope.setDirty();
                };

                $scope.getPlanLookups = function () {
                    businessPlanningService
                        .getPlanLookups()
                        .then(function (planLookups) {
                            $scope.planLookups = planLookups;
                        });
                };

                // Download Attachments withing followup modals
                $scope.getDownloadAttachmentUrl = function (attachmentId, delivAssessment) {
                    var planInitId = $scope.delivAssessment.PlanInitiativeID;
                    var planDelivId = $scope.delivAssessment.MilestoneGroupID;
                    delivAssessment = delivAssessment || $scope.delivAssessment;

                    return initiativeUpdateStatusService
                        .getDownloadAttachmentUrl(
                            $stateParams.ItemPersonID,
                            planInitId,
                            planDelivId,
                            delivAssessment.PlanDeliverableAssessmentID,
                            attachmentId);
                }

                $scope.init = function () {

                    initiativeUpdateStatusService
                        .getFollowUpsByPlanDeliverableID($scope.delivAssessment.PlanInitiativeID,
                                                        $scope.delivAssessment.MilestoneGroupID)
                        .then(function (delivAssContainers) {
                            $scope.delivAssContainers = delivAssContainers;

                            if (_.size(delivAssContainers) > 0) {
                                $scope.currentFollowUps = delivAssContainers[0].FollowUps;
                            }

                            $scope.setDirty();
                        });

                    if (!$scope.delivAssessment.AssessmentCompletionPercentage) {
                        $scope.delivAssessment.AssessmentCompletionPercentage =
                            $scope.delivAssessment.MilestoneGroup.CompletionPercentage;
                    }

                    $scope.attr = {
                        isReadOnly: true,
                        isCompleted: isCompleted(),
                        isInProgress: isInProgress(),
                        showDatePicker: false,
                        isLoading: false,
                        isShowActions: false,
                        isFormValid: areAllFieldsValid(),
                        completionPercentage: $scope.delivAssessment.AssessmentCompletionPercentage,
                        isCompletionPercentageValid: $scope.delivAssessment.AssessmentCompletionPercentage > 0,
                        isSubmitted: 'False',
                        isFormInvalidError: false,
                        showRequireFollowUpError: false,
                        isShowSubmitted: $scope.delivAssessment.IsSubmitted
                    };

                    $scope.delivAssessment.MilestoneGroup.TargetDate =
                        moment($scope.delivAssessment.MilestoneGroup.TargetDate).format();

                    if ($scope.delivAssessment.AssessmentTargetDate) {
                        $scope.delivAssessment.AssessmentTargetDate =
                            moment($scope.delivAssessment.AssessmentTargetDate).format();
                    }

                    if (_.isUndefined($scope.initUpdStatusAssessment)) return;
                    if (_.isUndefined($scope.initUpdStatusAssessment.PlanInitiative)) return;

                    $scope.attr.isReadOnly = $scope.delivAssessment.IsReadOnly ||
                                             !$scope.initUpdStatusAssessment.PlanInitiative.CanAssess ||
                                             $scope.delivAssessment.PlanInitiative_IsLocked;
                };

                // View FollowUps
                $scope.viewFollowUps = function () {
                    var modalScope = followUpService.openFollowUpsModal(null,
                                                                        $scope.delivAssessment,
                                                                        $scope.currentFollowUps,
                                                                        $scope.delivAssContainers,
                                                                        $scope.getDownloadAttachmentUrl);

                    modalScope.submitFollowUp = function (followUp) {
                        return initiativeUpdateStatusService
                                    .createPlanDeliverableAssessmentFollowUp($stateParams.ItemPersonID,
                                                                             $scope.delivAssessment.PlanInitiativeID,
                                                                             $scope.delivAssessment.MilestoneGroupID,
                                                                             $scope.delivAssessment.PlanDeliverableAssessmentID,
                                                                             followUp)
                                    .then(function (assessmentContainer) {
                                        var newFollowUp = assessmentContainer.FollowUps[0];
                                        modalScope.currentFollowUps.unshift(newFollowUp);
                                        $scope.currentFollowUps = modalScope.currentFollowUps;
                                        $scope.setDirty();
                                    });
                    };
                };

                // Are FollowUps Required
                function areFollowUpsRequired() {
                    if ($scope.delivAssessment.AssessmentCompletionStatusID === 120) { // NoIssue (on Track)

                        var initialAssessmentTargetDate = moment($scope.initialAssessmentTargetDate)

                        // if new target date is the same or before no comment needed
                        if (initialAssessmentTargetDate.isSame($scope.delivAssessment.AssessmentTargetDate) ||
                            initialAssessmentTargetDate.isAfter($scope.delivAssessment.AssessmentTargetDate)) {
                            return false;
                        }
                    }
                    if ($scope.delivAssessment.AssessmentCompletionStatusID === 119) { // completed

                        var initialAssessmentTargetDate = moment($scope.initialAssessmentTargetDate)

                        // if completion date is before target date no comment needed
                        if (initialAssessmentTargetDate.isAfter($scope.delivAssessment.AssessmentCompletionDate)) {
                            return false;
                        }
                    }

                    if ($scope.delivAssessment.AssessmentCompletionStatusID === 123) return false; // NotStarted

                    var areFollowUpsByAssessorPresent =
                            _.chain($scope.currentFollowUps)
                             .filter({ UserIsAssessor: true })
                             .some(function (followUp) {
                                if (followUp.Comment) return true;

                                return _.size(followUp.Attachments) > 0;
                             })
                             .value();

                    return !areFollowUpsByAssessorPresent;
                }

                function areAllFieldsValid() {
                    if (!$scope.delivAssessment.AssessmentCompletionStatusID) return false;
                    if (areFollowUpsRequired()) return false;

                    var conditions = $scope.delivAssessment.AssessmentFieldConditions_ByCompletionStatusID,
                        statusID = $scope.delivAssessment.AssessmentCompletionStatusID;

                    if (_.isNumber(statusID)) statusID = statusID.toString();

                    for (var attribute in conditions[statusID]) {
                        if (conditions[statusID].hasOwnProperty(attribute)
                            && conditions[statusID][attribute].required
                            && conditions[statusID][attribute].required === 'true'
                            && !$scope.delivAssessment[attribute]) {
                            return false;
                        }
                    }

                    return !areFollowUpsRequired();
                }

                // Is Field Required?
                function isFieldRequired(fieldName) {
                    if (_.isUndefined(fieldName)) return false;
                    if (_.isUndefined($scope.delivAssessment.AssessmentFieldConditions_ByCompletionStatusID)) return false;

                    var conditionsByCompStatusID = $scope.delivAssessment.AssessmentFieldConditions_ByCompletionStatusID;
                    var compStatusID = $scope.delivAssessment.AssessmentCompletionStatusID;
                    if (_.isNumber(compStatusID)) compStatusID = compStatusID.toString();

                    var fieldConditions = conditionsByCompStatusID[compStatusID][fieldName];

                    if (_.isUndefined(fieldConditions)) return false;

                    return fieldConditions['required'];
                }

                function isCompleted() {
                    return $scope.delivAssessment.AssessmentCompletionStatus && $scope.delivAssessment.AssessmentCompletionStatus.Value === 'Completed';
                }

                function isInProgress() {
                    if (!$scope.delivAssessment.AssessmentCompletionStatus) return false;

                    return $scope.delivAssessment.AssessmentCompletionStatus.Value === 'No-Issue'
                        || $scope.delivAssessment.AssessmentCompletionStatus.Value === 'Issues-Being-Monitored'
                        || $scope.delivAssessment.AssessmentCompletionStatus.Value === 'Issues-To-Address';
                }
            }],
            link: function (scope, element, attrs) {
                scope.init();
                scope.getPlanLookups();
            }
        };
    }
})();
